<template>
  <BaseEditModal
    displayName="Provide Feedback"
    icon="mdi-comment-alert-outline"
    hideBottomButtons
    :hideTabs="true"
    :customState="objToSend"
    :tabs="tabs"
    @close="emit('close')">
    <template v-slot:prepend-buttons>
      <v-btn
        variant="flat"
        @click="emit('close')">
        Cancel
      </v-btn>
    </template>
    <template v-slot:append-buttons>
      <v-btn
        color="primary"
        variant="flat"
        :loading="loading"
        :disabled="
          loading || !objToSend.name || !objToSend.email || !objToSend.message
        "
        @click="
          acceptTelemetry();
          emit('close');
        ">
        <v-icon class="mr-2">mdi-check-circle</v-icon>
        Send
      </v-btn>
    </template>
  </BaseEditModal>
</template>
<script setup lang="ts">
import GiveFeedBackInner from './GiveFeedBackInner.vue';
import BaseEditModal from '@/components/Shared/Modals/BaseEditModal.vue';
import * as Sentry from '@sentry/vue';
import { ref, reactive } from 'vue';
const loading = ref(false);
const objToSend = ref({
  name: '',
  email: '',
  message: '',
});
const emit = defineEmits({
  close: () => true,
  override: (override: boolean) => override,
});
async function acceptTelemetry() {
  if (
    !objToSend.value.name ||
    !objToSend.value.email ||
    !objToSend.value.message
  ) {
    return;
  }
  loading.value = true;
  Sentry.captureFeedback(objToSend.value);
  loading.value = false;
}
const tabs = [
  {
    id: 0,
    title: 'Send us feedback so we can improve',
    icon: 'mdi-bug-check-outline',
    display: true,
    component: GiveFeedBackInner,
    props: { customState: objToSend },
  },
];
</script>
<style scoped></style>
